import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { AuthGuardMain } from "../auth/auth-guard.service";
import { PermissionGuard } from "../guards/permisson.guard";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    canActivate: [],
    children: [
      { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
      { path: "dashboard", loadChildren: () => import("./dashboard/dashboard.module").then((m) => m.DashboardModule) },
      {
        path: "user",
        loadChildren: () => import("./user-management/user-management.module").then((m) => m.UserManagementModule),
      },
      {
        path: "school",
        loadChildren: () => import("./schools-college/schools-college.module").then((m) => m.SchoolsCollegeModule),
      },
      {
        path: "manager",
        loadChildren: () =>
          import("./manager-management/manager-management.module").then((m) => m.ManagerManagementModule),
      },
      {
        path: "scholarship",
        loadChildren: () =>
          import("./scholarship-management/scholarship-management-management.module").then(
            (m) => m.ScholarShipManagementModule
          ),
      },
      {
        path: "settings",
        loadChildren: () => import("./settings/settings.module").then((m) => m.SettingsModule),
      },
      {
        path: "application",
        loadChildren: () => import("./application/application.module").then((m) => m.ApplicationModule),
      },
      {
        path: "scholarship-app",
        loadChildren:()=>import("./scholarship-app/scholarship-app.module").then((m)=>m.ScholarshipAppModule)
      }

      // { path: 'analytic', loadChildren: () => import('./analytic/analytic.module').then(m => m.AnalyticModule)},
      // {
      //   path: 'password',
      //   loadChildren: () => import('../main/password/password.module').then(m => m.PasswordModule)
      // },
      // {
      //   path: 'user-management',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'users' },
      //   loadChildren: () => import('../main/user-management/user-management.module').then(m => m.UserManagementModule)
      // },
      // {
      //   path: 'feedback',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'users' },
      //   loadChildren: () => import('../main/feedback-management/feedback-management.module').then(m => m.FeedbackManagementModule)
      // },

      // {
      //   path: 'roles',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'roles' },
      //   loadChildren: () => import('../main/roles/roles.module').then(m => m.RolesModule)
      // },

      // {
      //   path: 'vehicle',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'vehicles' },
      //   loadChildren: () => import('../main/vehicle/vehicle.module').then(m => m.VehicleModule)
      // },
      // {
      //   path: 'passenger',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'passengers' },
      //   loadChildren: () => import('../main/passenger/passenger.module').then(m => m.PassengerModule)
      // },
      // {
      //   path: 'profile',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'passengers' },
      //   loadChildren: () => import('../main/profile-management/profile-management.module').then(m => m.ProfileManagementModule)
      // },
      // {
      //   path: 'category',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'passengers' },
      //   loadChildren: () => import('../main/category-management/category-management.module').then(m => m.CategoryManagementModule)
      // },
      // {
      //   path: 'payment-management',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'invoice' },
      //   loadChildren: () => import('../main/payment-management/payment-management.module').then(m => m.PaymentManagementModule)
      // },
      // {
      //   path: 'order',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'invoice' },
      //   loadChildren: () => import('../main/order-management/order-management.module').then(m => m.OrderManagementModule)
      // },
      // {
      //   path: 'fare',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'invoice' },
      //   loadChildren: () => import('../main/fare-management/fare-management.module').then(m => m.FareManagementModule)
      // },
      // {
      //   path: 'promo',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'invoice' },
      //   loadChildren: () => import('../main/promo-management/promo-management.module').then(m => m.PromoManagementModule)
      // },
      // {
      //   path: 'banner',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'invoice' },
      //   loadChildren: () => import('../main/banner-management/banner-management.module').then(m => m.BannerManagementModule)
      // },
      // {
      //   path: 'pickdrop',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'invoice' },
      //   loadChildren: () => import('../main/pickdrop-management/pickdrop-management.module').then(m => m.PickdropManagementModule)
      // },
      // {
      //   path: 'menu',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'invoice' },
      //   loadChildren: () => import('../main/menu-management/merchant-management.module').then(m => m.MenuManagementModule)
      // },
      // {
      //   path: 'merchant',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'invoice' },
      //   loadChildren: () => import('../main/merchant-management/merchant-management.module').then(m => m.MerchantManagementModule)
      // },

      // {
      //   path: 'driver-management',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'drivers' },
      //   loadChildren: () => import('../main/driver-management/driver-management.module').then(m => m.DriverManagementModule)
      // },
      // {
      //   path: 'reports-management',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'EO' },
      //   loadChildren: () => import('../main/report-management/report-management.module').then(m => m.ReportManagementModule)
      // },
      // {
      //   path: 'trips-management',
      //   canActivate: [ PermissionGuard ],
      //   data: { access: 'trips' },
      //   loadChildren: () => import('../main/trips-management/trips-management.module').then(m => m.TripsManagementModule)
      // },
      //   {
      //     path: 'stakeholder',
      //      canActivate: [ PermissionGuard ],
      //      data: { access: 'stakeholders' },
      //     loadChildren: () => import('../main/stack-holder/shareholder.module').then(m => m.ShareholderModule)
      //   },
      //   {
      //     path: 'payout',
      //     loadChildren: () => import('../main/payout/payout.module').then(m => m.PayoutModule)
      //   },
      //   { path: 'covid',canActivate: [ PermissionGuard ],data: { access: 'covidTracker' }, loadChildren: () => import('../main/covid/covid.module').then(m => m.CovidModule)},
      //   { path: 'terminal-management',canActivate: [ PermissionGuard ],data: { access: 'terminals' }, loadChildren: () => import('../main/terminal-management/terminal-management.module').then(m => m.TerminalManagementModule)},
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
